import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d2198f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "deployment-view" }
const _hoisted_2 = { class: "text-wrap text-truncate" }
const _hoisted_3 = { class: "dt-container dt-container--tabbed" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "py-2" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "mt-0 mb-3" }, "Deployment Overview"),
  /*#__PURE__*/_createElementVNode("p", null, "Follow the instructions here to zero-touch deploy Ditto Receiver and Ditto Connect applications at your organization or school."),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, [
    /*#__PURE__*/_createElementVNode("em", null, [
      /*#__PURE__*/_createElementVNode("strong", null, "Note"),
      /*#__PURE__*/_createTextVNode(": Mass deployment is an advanced deployment method. If you do not wish to mass deploy, simply follow the "),
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://help.airsquirrels.com/ditto/80-ditto-setup-guide",
        target: "_blank",
        rel: "noreferrer noopener",
        class: "link"
      }, "Ditto Setup Guide"),
      /*#__PURE__*/_createTextVNode(" to begin using Ditto. If you would like to continue with mass deployment and need assistance, "),
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://help.airsquirrels.com/ditto/kb-tickets/new",
        target: "_blank",
        rel: "noreferrer noopener",
        class: "link"
      }, "contact a Ditto specialist"),
      /*#__PURE__*/_createTextVNode(".")
    ])
  ])
], -1))
const _hoisted_5 = { class: "callout callout--warning mt-3" }
const _hoisted_6 = {
  class: "icon icon--x-large icon--warning",
  viewBox: "0 0 24 24"
}
const _hoisted_7 = ["d"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "A minor modification to the way traffic routes through your network may be required to use Ditto.", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://help.airsquirrels.com/ditto/351-configuring-your-network-for-ditto",
    target: "_blank",
    rel: "noreferrer noopener",
    class: "link"
  }, "Click here"),
  /*#__PURE__*/_createTextVNode(" for details and other network setup tips to ensure Ditto works on your network.")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Instructions for mass-deploying Ditto Receiver", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ol", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("span", null, "Make sure your network is set up correctly"),
    /*#__PURE__*/_createElementVNode("p", null, "See the Network Requirements section above.")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("span", null, "Deploy Ditto Receiver"),
    /*#__PURE__*/_createElementVNode("p", null, "Ditto receiver apps run on Apple TV (4th generation and newer) and Windows devices connected to the primary display. It’s what users mirror to."),
    /*#__PURE__*/_createElementVNode("p", null, "Click the “Ditto tvOS Receiver” or “Ditto Windows Receiver” tab above and follow the directions to deploy the appropriate receiver across your organization or school. You may deploy a combination of receivers to fit your organization’s needs.")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("span", null, "Deploy Ditto Connect"),
    /*#__PURE__*/_createElementVNode("p", null, "Ditto Connect is the application people use to mirror their device screen to Ditto receivers."),
    /*#__PURE__*/_createElementVNode("p", null, "Follow the directions in the Ditto Connect tab above to deploy Ditto Connect to your users.")
  ])
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "py-2" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "mt-0 mb-3" }, "Deployment instructions for Ditto tvOS Receiver"),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "The Ditto tvOS Receiver can be deployed to Apple TV using an MDM system. Once deployed, Ditto Receiver will automatically pair to your account and can be linked to a room.")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Each MDM system supports Apple TV differently. Select the device management system your organization uses for managing Apple TV to display the correct deployment instructions and configuration.", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("em", null, "Don't have a solution for managing Apple TV? "),
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.jamf.com/request-trial/",
      target: "_blank",
      rel: "noreferrer noopener",
      class: "link"
    }, "Sign up for Jamf Pro")
  ])
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Use our quick link tool to quickly link existing rooms to receivers that are paired to your Ditto account.", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Automation", -1))
const _hoisted_17 = { class: "callout mt-3" }
const _hoisted_18 = {
  class: "icon icon--x-large",
  viewBox: "0 0 24 24"
}
const _hoisted_19 = ["d"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.airsquirrels.com/contact",
    target: "_blank",
    rel: "noreferrer noopener",
    class: "primary-color"
  }, "Contact a Ditto deployment expert"),
  /*#__PURE__*/_createTextVNode(" to enable “Auto-Create Rooms” and “Auto-Link Receivers to Rooms” for your organization. "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://help.airsquirrels.com/ditto/355-additional-mass-deployment-options",
    target: "_blank",
    rel: "noreferrer noopener",
    class: "primary-color"
  }, "Learn more.")
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Auto-Create Rooms", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Automatically create a room for each receiver that pairs with Ditto.", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("em", null, "We strongly recommend only enabling this during planned deployment so rooms are not created by mistake in the future.")
], -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Auto-Link Receivers to Rooms", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Automatically link auto-created rooms to receivers.", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("em", null, "If you do not have a sufficient number of available receivers in your Ditto account, receivers may fail to link without notice. We strongly recommend only enabling this during planned deployment so rooms are not linked by mistake in the future.")
], -1))
const _hoisted_27 = { class: "py-2" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mt-0 mb-3" }, "Deployment instructions for Ditto Windows Receiver", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("This process allows you to deploy, link and pair receivers remotely. Deploy the Ditto Receiver MSI file and the Ditto deployment registry key using Group Policy to automate Ditto Windows Receiver pairing. "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://help.airsquirrels.com/ditto/352-how-to-mass-deploy-the-ditto-windows-receiver",
    target: "_blank",
    rel: "noreferrer noopener",
    class: "link"
  }, "Check out our knowledge base for more information")
], -1))
const _hoisted_30 = { class: "d-flex flex-column flex-sm-row align-items-sm-center" }
const _hoisted_31 = {
  href: "http://airsquirrels.com/ditto/download",
  target: "_blank",
  rel: "noreferrer noopener"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Use our quick link tool to quickly link existing rooms to receivers that are paired to your Ditto account.", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Automation", -1))
const _hoisted_34 = { class: "callout my-3" }
const _hoisted_35 = {
  class: "icon icon--x-large",
  viewBox: "0 0 24 24"
}
const _hoisted_36 = ["d"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.airsquirrels.com/contact",
    target: "_blank",
    rel: "noreferrer noopener",
    class: "primary-color"
  }, "Contact a Ditto deployment expert"),
  /*#__PURE__*/_createTextVNode(" to enable “Auto-Create Rooms” and “Auto-Link Receivers to Rooms” for your organization. "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://help.airsquirrels.com/ditto/355-additional-mass-deployment-options",
    target: "_blank",
    rel: "noreferrer noopener",
    class: "primary-color"
  }, "Learn more.")
], -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Auto-Create Rooms", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Automatically create a room for each receiver that pairs with Ditto.", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("em", null, "We strongly recommend only enabling this during planned deployment so rooms are not created by mistake in the future.")
], -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Auto-Link Receivers to Rooms", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Automatically link auto-created rooms to receivers.", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("em", null, "If you do not have a sufficient number of available receivers in your Ditto account, receivers may fail to link without notice. We strongly recommend only enabling this during planned deployment so rooms are not linked by mistake in the future.")
], -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mt-0 mb-3" }, "Deployment instructions for Ditto Connect", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Ditto Connect is required to share content wirelessly to Ditto receivers. Direct users to access Ditto Connect on the "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "http://airsquirrels.com/ditto/download",
    target: "_blank",
    rel: "noreferrer noopener",
    class: "link"
  }, "Ditto downloads page"),
  /*#__PURE__*/_createTextVNode(" or by entering a room code at "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "http://connect.goditto.com",
    target: "_blank",
    rel: "noreferrer noopener",
    class: "link"
  }, "connect.goditto.com"),
  /*#__PURE__*/_createTextVNode(". Alternatively, you may choose to distribute the app to users via your preferred software deployment method.")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_m_d_m_deployment_instructions = _resolveComponent("m-d-m-deployment-instructions")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_TierLimit = _resolveComponent("TierLimit")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "primary-color",
        to: "/organization/company"
      }, {
        default: _withCtx(() => [
          _createTextVNode("My Organization")
        ]),
        _: 1
      }),
      _createTextVNode(" » Deployment ")
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
      _createVNode(_component_el_tabs, {
        modelValue: _ctx.activeTab,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.activeTab) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, {
            label: "Overview",
            name: "overview"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form, { "label-position": "top" }, {
                default: _withCtx(() => [
                  _hoisted_4,
                  _createVNode(_component_el_divider),
                  _createVNode(_component_el_form_item, {
                    class: "mb-0",
                    label: "Network Requirements"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_6, [
                          _createElementVNode("path", { d: _ctx.mdiTransitConnectionVariant }, null, 8, _hoisted_7)
                        ])),
                        _hoisted_8
                      ]),
                      _hoisted_9
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_divider),
                  _createVNode(_component_el_form_item, {
                    class: "mb-0",
                    label: "How to deploy Ditto"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10,
                      _hoisted_11
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, {
            label: "tvOS Receiver",
            name: "tvOSReceiver"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form, { "label-position": "top" }, {
                default: _withCtx(() => [
                  _hoisted_12,
                  _createVNode(_component_el_divider),
                  _createVNode(_component_el_form_item, { label: "Apple TV MDM" }, {
                    default: _withCtx(() => [
                      _hoisted_13,
                      _hoisted_14,
                      _createVNode(_component_el_select, {
                        class: "deployment__input-width-container",
                        placeholder: "Select an MDM",
                        modelValue: _ctx.mdmSelection,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mdmSelection) = $event)),
                        onChange: _ctx.mdmSelectionChange,
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mdmOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange"])
                    ]),
                    _: 1
                  }),
                  (_ctx.mdmSelection)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        label: 'Ditto tvOS Receiver deployment instructions for ' +  _ctx.mdmSelection
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_m_d_m_deployment_instructions, {
                            class: "my-2",
                            deploymentOption: _ctx.mdmSelection
                          }, null, 8, ["deploymentOption"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_divider),
                  _createVNode(_component_el_form_item, {
                    label: "Quick Link Rooms",
                    class: "my-0"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15,
                      _createVNode(_component_router_link, { to: { path: '/organization/deployment/quicklink'} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, { class: "el-button el-button--primary" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Begin Linking")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_divider),
                  _hoisted_16,
                  _createElementVNode("div", _hoisted_17, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_18, [
                      _createElementVNode("path", { d: _ctx.mdiAutoFix }, null, 8, _hoisted_19)
                    ])),
                    _hoisted_20
                  ]),
                  _createVNode(_component_el_form_item, { class: "my-4" }, {
                    default: _withCtx(() => [
                      _createElementVNode("label", null, [
                        _createVNode(_component_el_switch, {
                          modelValue: _ctx.deployment.autoCreateRooms,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.deployment.autoCreateRooms) = $event)),
                          disabled: !_ctx.deployment.exposeAutoDeploymentOptions,
                          onChange: _ctx.autoDeploymentChange
                        }, null, 8, ["modelValue", "disabled", "onChange"]),
                        _hoisted_21
                      ]),
                      _hoisted_22,
                      _hoisted_23
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { class: "m-0" }, {
                    default: _withCtx(() => [
                      _createElementVNode("label", null, [
                        _createVNode(_component_el_switch, {
                          modelValue: _ctx.deployment.autoLinkRooms,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.deployment.autoLinkRooms) = $event)),
                          disabled: !_ctx.deployment.exposeAutoDeploymentOptions || !_ctx.deployment.autoCreateRooms,
                          onChange: _ctx.autoDeploymentChange
                        }, null, 8, ["modelValue", "disabled", "onChange"]),
                        _hoisted_24
                      ]),
                      _hoisted_25,
                      _hoisted_26
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, {
            label: "Windows Receiver",
            name: "windowsReceiver"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form, { "label-position": "top" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _hoisted_29,
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", null, [
                        _createVNode(_component_el_button, {
                          class: "el-button el-button--primary me-sm-2",
                          onClick: _ctx.generateWindowsPairingKey
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Deployment Registry Key")
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("a", _hoisted_31, [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            plain: ""
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Download Ditto Receiver")
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ]),
                  _createVNode(_component_el_divider),
                  _createVNode(_component_el_form_item, {
                    label: "Quick Link Rooms",
                    class: "my-0"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_32,
                      _createVNode(_component_router_link, { to: { path: '/organization/deployment/quicklink'} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, { class: "el-button el-button--primary" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Begin Linking")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_divider),
                  _hoisted_33,
                  _createElementVNode("div", _hoisted_34, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_35, [
                      _createElementVNode("path", { d: _ctx.mdiAutoFix }, null, 8, _hoisted_36)
                    ])),
                    _hoisted_37
                  ]),
                  _createVNode(_component_el_form_item, { class: "my-4" }, {
                    default: _withCtx(() => [
                      _createElementVNode("label", null, [
                        _createVNode(_component_el_switch, {
                          modelValue: _ctx.deployment.autoCreateRooms,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.deployment.autoCreateRooms) = $event)),
                          disabled: !_ctx.deployment.exposeAutoDeploymentOptions,
                          onChange: _ctx.autoDeploymentChange
                        }, null, 8, ["modelValue", "disabled", "onChange"]),
                        _hoisted_38
                      ]),
                      _hoisted_39,
                      _hoisted_40
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { class: "m-0" }, {
                    default: _withCtx(() => [
                      _createElementVNode("label", null, [
                        _createVNode(_component_el_switch, {
                          modelValue: _ctx.deployment.autoLinkRooms,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.deployment.autoLinkRooms) = $event)),
                          disabled: !_ctx.deployment.exposeAutoDeploymentOptions || !_ctx.deployment.autoCreateRooms,
                          onChange: _ctx.autoDeploymentChange
                        }, null, 8, ["modelValue", "disabled", "onChange"]),
                        _hoisted_41
                      ]),
                      _hoisted_42,
                      _hoisted_43
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, {
            label: "Ditto Connect",
            name: "dittoConnect"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form, {
                "label-position": "top",
                class: "py-2"
              }, {
                default: _withCtx(() => [
                  _hoisted_44,
                  _hoisted_45
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])), [
      [_directive_loading, _ctx.viewLoading]
    ]),
    _createVNode(_component_TierLimit, {
      modelValue: _ctx.showTierCallout,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showTierCallout) = $event)),
      isCallout: false,
      isLimit: false,
      message: "Upgrade your Ditto account to unlock mass deployment."
    }, null, 8, ["modelValue"])
  ]))
}